// extracted by mini-css-extract-plugin
module.exports = {"progress":"Waveform_progress__32S1p","wave":"Waveform_wave__1AcCy","menu":"Waveform_menu__2ssfW"};